import type {
    InboxWorkflowCellComponent,
    InboxWorkflowRegistry,
} from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
import InputCell from "../_modules/input-cell"
import SelectCell from "../_modules/select-cell"
import StatusCell from "../_modules/status-cell"
import ToggleCell from "../_modules/toggle-cell"
import {
  customerContactCells,
  customerContactVerificationFlow,
} from "../flows/customer_contact_verification"
import {
  customerContactPointReviewCells,
  customerContactPointReviewFlow,
} from "../flows/customer_contact_point_review"
import { createLetterDeliveryBatchFlow, letterDeliveryCells } from "../flows/letter_delivery_batch"
import {
  unclearAppointmentFeedbackCells,
  unclearAppointmentFeedbackFlow,
} from "../flows/unclear_appointment_feedback"
import {
  wrongRecipientCells,
  wrongRecipientReplacementFlow,
} from "../flows/wrong_recipient_replacement"

const controlCells: Record<string, InboxWorkflowCellComponent> = {
  input: InputCell,
  select: SelectCell,
  status: StatusCell,
  toggle: ToggleCell,
}

export const buildKehrblattInboxWorkflowRegistry = (options: {
  trialRestrictionsActive: boolean
  automaticLetterDeliveryAllowed?: boolean
  automaticLetterDeliveryDisabledReason?: string | null
}): InboxWorkflowRegistry => ({
  cells: {
    ...controlCells,
    ...customerContactCells,
    ...customerContactPointReviewCells,
    ...wrongRecipientCells,
    ...unclearAppointmentFeedbackCells,
    ...letterDeliveryCells,
  },
  flows: {
    customer_contact_verification: customerContactVerificationFlow,
    customer_contact_point_review: customerContactPointReviewFlow,
    wrong_recipient_replacement: wrongRecipientReplacementFlow,
    unclear_appointment_feedback: unclearAppointmentFeedbackFlow,
    letter_delivery_batch: createLetterDeliveryBatchFlow({
      automaticLetterDeliveryAllowed: options.automaticLetterDeliveryAllowed !== false,
      automaticLetterDeliveryDisabledReason: options.automaticLetterDeliveryDisabledReason ?? null,
    }),
  },
})
